import { Group } from './../../user/model/user';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UserService } from 'src/app/core/service/user.service';
import { Component, OnInit, ChangeDetectorRef, AfterViewChecked, QueryList, ViewChildren, ElementRef } from '@angular/core';
import { ProgramCategoryList } from '../model/programCategoryList';
import { ProgramCategoryService } from 'src/app/core/service/program-category.service';
import { sortBy } from 'lodash';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { User } from 'src/app/user/model/user';
import { ProgramService } from 'src/app/core/service/program.service';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { Program } from '../model/program';
import { NGXLogger } from 'ngx-logger';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { Observable, forkJoin } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { DeactivationGuarded } from 'src/app/core/routing/can-deactivate-guard.service';
import { ChannelService } from 'src/app/core/service/channel.service';
import { Guid } from 'guid-typescript';
import { FlowableService } from 'src/app/core/service/flowable.service';
import { DocumentService } from 'src/app/core/service/document.service';
import { SettingService } from 'src/app/core/service/setting.service';
import { Organization } from 'src/app/core/model/organization';
import { OrganizationService } from 'src/app/core/service/organization.service';
import { TextProcessor } from 'src/app/core/utility/text.processor';
import { saveAs } from '@progress/kendo-file-saver';
import { GroupService } from 'src/app/core/service/group.service';
import { MetricService } from 'src/app/core/service/metric.service';
import { groupBy, GroupResult } from '@progress/kendo-data-query';
import { Channel } from 'src/app/channel/model/channel';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';

const swapArrayLocs = (arr: [], index1: number, index2: number) => { [arr[index1], arr[index2]] = [arr[index2], arr[index1]]; };

@Component({
  selector: 'app-program-edit',
  templateUrl: './program-edit.component.html',
  styleUrls: ['./program-edit.component.scss']
})
export class ProgramEditComponent implements OnInit, AfterViewChecked, DeactivationGuarded
{
  @ViewChildren(TooltipDirective) public tooltipDir: QueryList<TooltipDirective>;

  /**
   * Data model of the program.
   */
  public program: Program = new Program();

  /**
   * Angular form group for the channel.
   */
  public programForm: any;

  /**
   * Program Categories for drop-down.
   */
  public programCategories: ProgramCategoryList[] = [];

  /**
   * Filtered list of program categories for drop-down.
   */
  public programCategoriesFiltered: ProgramCategoryList[] = [];

  /**
   * Users for the program lead drop-down.
   */
  public programLeads: User[] = [];

  /**
   * Filtered list of program leads for drop-down.
   */
  public programLeadsFiltered: User[] = [];

  /**
   * Current search term entered from a comboxbox
   */
  public searchTerm: string;

  /**
   * Is this a new program?
   */
  public isNew: boolean;

  /**
   * Is this a new program template?
   */
  public isNewTemplate: boolean;

  /**
   * Indicates if the page is loading.
   */
  public loading = true;

  /**
   * Program Templates for drop-down.
   */
  public programTemplates: any[] = [];

  /**
   * Program Templates for drop-down.
   */
  public programTemplatesFiltered: any[] = [];

  /**
   * Program's Channels.
   */
  public channels: UntypedFormArray;

  /**
   * Program's Metrics.
   */
  public metrics: UntypedFormArray;

  /**
   * Index of the model when importing
   */
  public importIndex: number = null;

  public programDetailsCollapsed = false;
  public channelDetailsCollapsed = false;
  public changeChannelOrderSwitch = false;
  public programMetricsCollapsed = false;

  /**
   * Control if Program Lead have disabled access to program/workflow
   */
  public channelDisabled = false;

  /**
   * List of available organizations
   */
  public organizations: Organization[];

  /**
   * Filtered list of organizations for drop-down.
   */
  public organizationsFiltered: Organization[] = [];

  /**
   * Coordinator service admin role?
   */
  public isCommunityCoordinatorRole = false;

  public currentUserOrganization: Organization;

  /**
   * Filtered list of channel groups for drop-down.
   */
  public programGroupsFiltered: Group[] = [];

  public templateChannels: any[];
  public templateGroupedChannels: GroupResult[] = [];

  /**
   * Is new program cancelled?
   */
  private newProgramCancelled = false;

  /**
   * Current logged in user
   */
  private currentUser: User;

  /**
   * Program ID.
   */
  private programId: number;

  /**
   * Default text when creating a new channel
   */
  private ruleSetText: string;

  /**
   * Current templateId being selected on new
   */
  private templateId: number = null;

  /**
   * Users for the channel groups drop-down.
   */
  private programGroups: Group[] = [];

  private allMetrics: any[] = [];

  constructor(
    private programCategoryService: ProgramCategoryService,
    private userService: UserService,
    private programService: ProgramService,
    private authenticationService: AuthenticationService,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private logger: NGXLogger,
    private messageHandlerService: MessageHandlerService,
    private changeDetectorRef: ChangeDetectorRef,
    private appComponent: AppComponent,
    private channelService: ChannelService,
    private flowableService: FlowableService,
    private translate: TranslateService,
    private documentService: DocumentService,
    private settingService: SettingService,
    private groupService: GroupService,
    private organizationService: OrganizationService,
    private metricService: MetricService
  )
  {
    this.buildForm();
  }

  /**
   * Getter for form control field groupsIds.
   */
  public get groups(): UntypedFormControl
  {
    return this.programForm.get('groups');
  }

  /**
   * Getter for form control field leader.
   */
  public get leader(): UntypedFormControl
  {
    return this.programForm.get('leader');
  }

  /**
   * Getter for form control field category.
   */
  public get category(): UntypedFormControl
  {
    return this.programForm.get('category');
  }

  /**
   * Getter for form control field name.
   */
  public get name(): UntypedFormControl
  {
    return this.programForm.get('name');
  }

  /**
   * Getter for form control field description.
   */
  public get description(): UntypedFormControl
  {
    return this.programForm.get('description');
  }

  /**
   * Getter for form control field id.
   */
  public get id(): UntypedFormControl
  {
    return this.programForm.get('id');
  }

  /**
   * Getter for form control field organization.
   */
  public get organization(): UntypedFormControl
  {
    return this.programForm.get('organization');
  }

  /**
   * Getter for form control field isTemplate.
   */
  public get isTemplate(): UntypedFormControl
  {
    return this.programForm.get('isTemplate');
  }

  public ngOnInit(): void
  {
    this.currentUser = this.authenticationService.currentUser;

    this.translate.get('NEW-ENROLLMENT-CRITERIA-DEFAULT-NAME').subscribe({
      next: (value) =>
      {
        this.ruleSetText = value;
      }
    });

    this.settingService.getCachedSessionSettings().subscribe({
      next: (sessionSetting) =>
      {
        // Enforce Program Leads access to program/worfklow
        if (sessionSetting.workflowRestrictedUsers !== '')
        {
          const currentUser = this.authenticationService.currentUser;
          if (currentUser && currentUser.role === 'ROLE_PROGRAM_LEAD')
          {
            const restrictedUsers = sessionSetting.workflowRestrictedUsers.split(',');
            restrictedUsers.every((id: string) =>
            {
              if (parseInt(id, 10) === currentUser.id)
              {
                this.channelDisabled = true;
              }
              return !this.channelDisabled;  // Stop iteration when set to false
            });
          }
        }
      },
      error: (error) =>
      {
        this.messageHandlerService.displayError(error);
      }
    });

    this.groupService.getGroups().subscribe({
      next: (data) =>
      {
        this.programGroups = data;
        this.filterProgramGroups('');
      },
      error: (errorResponse: any) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });

    // Get Program Categories
    this.programCategoryService.getCachedProgramCategories().subscribe({
      next: data =>
      {
        this.programCategories = data;
        this.filterProgramCategories('');
      },
      error: (error) =>
      {
        this.messageHandlerService.displayError(error);
      }
    });

    // Get Organizations
    this.organizationService.getCachedOrganizations().subscribe({
      next: (data) =>
      {
        this.organizations = data;
        this.filterOrganizations('');
      },
      error: (error) =>
      {
        this.messageHandlerService.displayError(error);
      }
    });

    // Initialize isNewTemplate
    this.isNewTemplate = false;
    this.route.queryParams.subscribe({
      next: (params) =>
      {
        this.isNewTemplate = params.template || false;
      }
    });

    this.userService.getUserById(this.currentUser.id, false).subscribe({
      next: (user) =>
      {
        this.isCommunityCoordinatorRole = user.role === 'ROLE_COMMUNITY_COORDINATOR';
        this.currentUserOrganization = user.organization;

        this.userService.getCachedUsers().subscribe({
          next: (data) =>
          {
            this.programLeads = data;
            this.filterProgramLeads('');

            // Get metrics
            this.metricService.getMetrics().subscribe({
              next: (metrics) =>
              {
                this.allMetrics = sortBy(metrics, ['name']);

                this.route.params.forEach((params: Params) =>
                {
                  if (params.id !== undefined)
                  {
                    this.programId = +params.id;
                    this.isNew = false;

                    // Retrieve this program from REST service
                    this.getProgram();
                  }
                  else // No program ID in route, this is a new program.
                  {
                    this.programService.getProgramsTemplates().subscribe({
                      next: (templates) =>
                      {
                        this.programTemplates = templates;
                        this.filterProgramTemplates('');
                      }
                    });

                    this.program =
                    {
                      id: null,
                      name: null,
                      active: true,
                      description: null,
                      leader: null,
                      category: null,
                      organization: this.currentUserOrganization,
                      version: 0,
                      isTemplate: this.isNewTemplate,
                      channels: this.formBuilder.array([]),
                      metrics: this.formBuilder.array([]),
                      ruleSetText: null,
                      template: null,
                      groups: null
                    };

                    this.isNew = true;
                    this.buildForm();
                  }
                });
              },
              error: (errorResponse: any) =>
              {
                this.messageHandlerService.displayError(errorResponse);
              }
            });
          },
          complete: () =>
          {
            this.loading = false;
          }
        });
      },
      error: (error) =>
      {
        this.messageHandlerService.displayError(error);
      }
    });

    // Load all Channels from Program Templates and keep them available for new Channels
    this.channelService.getCacheMinimalChannels('?templateOnly=true').subscribe({
      next: (channelData) =>
      {
        this.templateChannels = channelData;
        this.templateChannels.forEach(d =>
        {
          d.programName = d.program.name;
        });
        this.setGroupedTemplateChannels();
      }
    });
  }

  /**
   * Explicit change detection handler to avoid "expression-has-changed-after-it-was-checked-error".
   */
  public ngAfterViewChecked(): void
  {
    this.changeDetectorRef.detectChanges();
  }

  /**
   * Filters the program categories based on user input.
   */
  public filterProgramCategories(filterValue: string): void
  {
    this.programCategoriesFiltered = sortBy(this.programCategories
      .filter(category => category.name.toLowerCase().includes(filterValue.toLowerCase())), ['name']);
  }

  /**
   * Filter the organizations based on user input.
   */
  public filterOrganizations(filterValue: string): void
  {
    this.organizationsFiltered = sortBy(this.organizations
      .filter(organization => organization.name.toLowerCase().includes(filterValue.toLowerCase())), ['name']);
  }

  /**
   * Disable inactive items from drop-down.
   *
   * @param itemArgs Item object
   */
  public itemDisabled(itemArgs: { dataItem: any; index: number }): boolean
  {
    return !itemArgs.dataItem.active;
  }

  /**
   * Filters the program leads based on user input.
   */
  public filterProgramLeads(filterValue: string): void
  {
    this.searchTerm = filterValue;
    this.programLeadsFiltered = sortBy(this.programLeads
      .filter(user => user.name.toLowerCase().includes(filterValue.toLowerCase())), ['name']);
  }

  /**
   * Check if user from dropdown is disabled or enabled.
   *
   * @returns boolean
   */
  public programLeadItemDisabled(itemArgs: { dataItem: any; index: number }): boolean
  {
    return !itemArgs.dataItem.enabled;
  }

  /**
   * Filters the program templates based on user input.
   */
  public filterProgramTemplates(filterValue: string): void
  {
    this.programTemplatesFiltered = this.programTemplates
      .filter(program => program.name.toLowerCase().includes(filterValue.toLowerCase()));
  }

  /**
   * Disable buttons based on program status.
   */
  public disableFormControl(): boolean
  {
    return !this.program.active;
  }

  /**
   * Determines if a field in the program FormGroup is valid.
   */
  public formFieldInvalid(field: string): boolean
  {
    return this.programForm.controls[field].touched && this.programForm.controls[field].invalid;
  }

  /**
   * canDesactivate event implementation for monitoring if dirty changes and navigation without saving
   */
  public canDeactivate(): boolean | Observable<boolean> | Promise<boolean>
  {
    if (!this.newProgramCancelled && ((this.programForm && this.programForm.dirty) || this.isNew))
    {
      this.appComponent.openUnsavedDialog();
      return this.appComponent.navigateAwaySelection;
    }
    else
    {
      return true;
    }
  }

  /**
   * Cancels the creation of a new program,
   * and navigates back to the programs component.
   */
  public cancelNewProgram(): void
  {
    this.newProgramCancelled = true;
    this.router.navigateByUrl(this.isNewTemplate ? `/program-templates` : `/programs/all`);
  }

  /**
   * If true, disables the "Save" button.
   */
  public disableSave(): boolean
  {
    return this.program.active === false || !this.programForm.valid || !this.programForm.dirty;
  }

  /**
   * Return the Channel Status Key for translation.
   *
   * @param channelStatus Current channel status.
   */
  public getChannelStatusKey(channelStatus: string): string
  {
    return this.channelService.getChannelStatusKey(channelStatus);
  }

  /**
   * Form submission event handler.
   */
  public onSubmit(): void
  {
    // Make sure there is one channel added. Only perform the validation for new Program.
    if (this.id.value === null)
    {
      const validChannels = this.programForm.get('channels').value.find(x => x.status !== 'Deleted');
      if (validChannels === undefined)
      {
        this.messageHandlerService.displayWarning('PROGRAM-NO-CHANNEL-FOUND');
        return;
      }
    }

    // Validate program metrics to ensure it is selected once
    const metricIds = [];
    let duplicatedMetrics = false;
    this.programForm.get('metrics').controls.forEach(c =>
    {
      if (metricIds.includes(c.value.metric.id))
      {
        duplicatedMetrics = true;
      }
      metricIds.push(c.value.metric.id);
    });

    if (duplicatedMetrics)
    {
      this.messageHandlerService.displayWarning('PROGRAM-METRIC-MUST-BE-SELECTED-ONCE');
      return;
    }

    this.program = this.programForm.value;
    this.program.groups = this.program.groups !== null ? this.program.groups.map((g: Group) => g.id) : null;

    if (this.isNew)
    {
      this.program.version = 0;
      this.program.active = true;
    }

    // If copied by a template, set the id
    // Channels staff, goals, ruleSet, queryRules will be copied server-side
    this.templateId = this.program.template ? this.program.template.id : null;

    // Set program.channels based on selected channels
    this.program.channels = [];
    const addUpdateChannels = [];
    this.programForm.get('channels').controls.forEach(c =>
    {
      addUpdateChannels.push(c.value);
    });
    this.program.channels = addUpdateChannels;

    // Set program.metrics based on the selected metrics
    this.program.metrics = [];
    const addUpdateMetrics = [];
    this.programForm.get('metrics').controls.forEach(m =>
    {
      m.value.metricId = m.value.metric.id;
      addUpdateMetrics.push(m.value);
    });
    this.program.metrics = addUpdateMetrics;

    delete this.program.template;

    this.program.leader = { id: this.leader.value.id, name: this.leader.value.name };
    this.program.category = { id: this.category.value.id, name: this.category.value.name };
    this.program.ruleSetText = this.ruleSetText;

    // Create business process for each new Channels
    const listQueries: any = [];
    const bpmKeysMap: Map<string, number> = new Map();    // Map of bpmKey and copyChannelId

    this.program.channels.forEach((channel: any) =>
    {
      // Create business process if channel id is null and not model imported
      if (channel.id === null && channel.channelZip === null)
      {
        // If Channel Template is selected, set the copyChannelId
        if (channel.templateChannel !== null)
        {
          channel.copyChannelId = channel.templateChannel.id;
        }

        const bpmKey = Guid.create().toString();
        const bpm = {
          name: this.channelService.buildBPMDefaultName(channel.name),
          key: bpmKey,
          description: channel.name,
          modelType: 0
        };

        channel.bpmKey = bpmKey;    // Set bpmKey to guid to match results and program.channels
        bpmKeysMap.set(bpmKey, channel.copyChannelId);

        listQueries.push(this.flowableService.createProcess(bpm));
      }
    });

    if (listQueries.length > 0)
    {
      this.createBusinessProcesses(listQueries).subscribe({
        next: (results) =>
        {
          // Set channels business process variables
          results.forEach(data =>
          {
            const channelIndex = this.program.channels.findIndex(c => c.bpmKey === data.key);
            if (channelIndex >= 0)
            {
              this.program.channels[channelIndex].bpmId = data.id;
              this.program.channels[channelIndex].bpmKey = data.key;
              this.program.channels[channelIndex].bpmName = data.name;
            }
          });

          this.saveProgram();

          // If a template is selected, must update model for each created channels
          results.forEach(data =>
          {
            let templateBpmId = null;
            const channelIndex = this.program.channels.findIndex((c: any) => c.bpmKey === data.key);

            // Must get the original bpmId if Channel Template is used
            if (this.program.channels[channelIndex].templateChannel !== null)
            {
              templateBpmId = this.program.channels[channelIndex].templateChannel.bpmId;
            }
            // Must get the original bpmId if Program Template is used
            else if (this.templateId !== null)
            {
              templateBpmId = this.findBpmIdFromTemplate(data.key, bpmKeysMap, this.templateId);
            }

            if (templateBpmId !== undefined && templateBpmId !== null)
            {
              // Copy Business Process from Template
              this.flowableService.getModelSource(templateBpmId).subscribe({
                next: (templateModel) =>
                {
                  templateModel.lastUpdated = data.lastUpdated;
                  templateModel.key = data.key;
                  templateModel.name = data.name;
                  templateModel.modelId = data.id;
                  templateModel.model.modelId = data.id;
                  this.flowableService.updateModelSource(data.id, templateModel).subscribe({
                    error: (error) =>
                    {
                      this.logger.error(error);
                      this.messageHandlerService.displayDirectMessage('error', error.message);
                    }
                  });
                },
                error: (error) =>
                {
                  this.logger.error(error);
                  this.messageHandlerService.displayDirectMessage('error', error.message);
                }
              });
            }
          });
        }
      });
    }
    else
    {
      this.saveProgram();
    }
  }

  public createBusinessProcesses(listQueries: any): Observable<any>
  {
    return forkJoin(listQueries);
  }

  /**
   * Save the current Program
   */
  public saveProgram(): void
  {
    this.loading = true;

    this.programService.saveProgram(this.program, this.isNew, this.programId).subscribe({
      next: (data) =>
      {
        this.setProgramData(data);
        this.messageHandlerService.displaySuccess('PROGRAM-SAVED-SUCCESSFULLY');

        // Must navigate to program to prevent creating a new program if browser is refreshed
        if (this.isNew)
        {
          this.router.navigate([`/program-edit/${this.program.id}`]);
        }
        else
        {
          this.buildForm();
        }
      },
      error: (error) =>
      {
        this.logger.error(error);

        // Error occurred during save, reset the model and display error message
        this.messageHandlerService.displayDirectMessage('error', error.message);
        this.program = new Program();
        this.buildForm();
      },
      complete: () =>
      {
        // With a successful save, we need to update this boolean so the header shows appropriate data.
        if (this.isNew)
        {
          this.isNew = false;
          this.programId = Number(this.program.id);
          this.router.navigateByUrl(`/program-edit/${this.programId}`);
        }
        this.buildForm();
        this.loading = false;
      }
    });
  }

  public onAddChannel(): void
  {
    const programName = this.name.value ? this.name.value + ' ' : '';
    this.translate.get('NEW-CHANNEL-DEFAULT-NAME').subscribe({
      next: (value) =>
      {
        this.addUpdateChannel(null, `${programName}${value}`, this.isNewTemplate || this.program.isTemplate ? 'Template' : 'Offline',
          null, null, null, null, null, 0, this.program.id, null, true);
        this.programForm.markAsDirty();
      }
    });
  }

  public onAddMetric(): void
  {
    this.addUpdateMetric(null, null, null, null, null, null, null, 0);
    this.programForm.markAsDirty();
  }

  /**
   * Navigates to channel edit.
   */
  public onEditChannel(channelId: number): void
  {
    this.router.navigate([`/channel-edit/${channelId}`]);
  }

  /**
   * Remove channel from selection.
   */
  public removeChannel(i: number, id: number): void
  {
    const channels = this.programForm.controls.channels;

    // Make sure if channel model is selected it is deleted
    this.deleteChannelZip(i);

    // If this id was already persisted, we must remove
    if (id > 0)
    {
      (channels as UntypedFormArray).controls[i].get('status').setValue('Deleted');
    }
    else
    {
      (channels as UntypedFormArray).removeAt(i);
    }
    this.programForm.markAsDirty(); // Must force mark as dirty when removing a channel.
  }

  public exportModel(i: number): void
  {
    const channels = this.programForm.controls.channels;
    const appId = (channels as UntypedFormArray).controls[i].get('appId').value;
    const bpmName = (channels as UntypedFormArray).controls[i].get('bpmName').value;
    const bpmId = (channels as UntypedFormArray).controls[i].get('bpmId').value;
    if (appId !== undefined && appId !== null && bpmId !== undefined && bpmId !== null)
    {
      this.flowableService.generateZip(appId, bpmId).subscribe({
        next: (data) =>
        {
          saveAs(`data:${data.mimeType};base64,${data.content}`, bpmName);
        }
      });
    }
  }

  /**
   * Channel Template selection changed.
   *
   * @param selectedChannelTemplate Selected Channel Template
   * @param index Index of the current position is the list
   */
  public templateChannelChange(selectedChannelTemplate: Channel, index: number): void
  {
    if (selectedChannelTemplate !== undefined)
    {
      const channels = this.programForm.controls.channels;
      (channels as UntypedFormArray).controls[index].get('name').setValue(selectedChannelTemplate.name);
    }
  }

  public deleteChannelZip(index: number): void
  {
    const channels = this.programForm.controls.channels;
    (channels as UntypedFormArray).controls[index].get('channelZip').setValue(null);
    (channels as UntypedFormArray).controls[index].get('modelFileName').setValue(null);
  }

  public onFileChanged(event: Event): void
  {
    const input = event.target as HTMLInputElement;
    const fileList: FileList = input.files;
    if (fileList.length > 0)
    {
      const file: File = fileList[0];
      const formData: FormData = new FormData();
      formData.append('file', file, file.name);

      this.documentService.uploadModel(formData).subscribe({
        next: (data) =>
        {
          // Show a success
          this.messageHandlerService.displaySuccess('DOCUMENT-ADDED-SUCCESFULLY');

          const channels = this.programForm.controls.channels;
          (channels.controls[this.importIndex] as UntypedFormGroup).get('channelZip').setValue(data.substr(data.length - 12));
          (channels.controls[this.importIndex] as UntypedFormGroup).get('modelFileName').setValue(file.name);
          (channels.controls[this.importIndex] as UntypedFormGroup).get('templateChannel').setValue(null); // Clear selected Channel

          this.programForm.markAsDirty();
        },
        error: (error) =>
        {
          this.messageHandlerService.displayError(error);
        }
      });
    }
    input.value = '';
  }

  public validateKey(e: KeyboardEvent): void
  {
    TextProcessor.validateKey(e);
  }

  public updateOrganization(filterValue: any): void
  {
    if (filterValue !== undefined && filterValue !== null)
    {
      this.organization.setValue({ id: filterValue.organization.id, name: filterValue.organizationName });
    }
    else
    {
      this.organization.setValue(null);
    }
  }

  public changeChannelOrder(index: number, direction: string): void
  {
    swapArrayLocs(this.programForm.controls.channels.controls, index, direction === 'up' ? index - 1 : index + 1);
    this.programForm.markAsDirty();
  }

  /**
   * Filters the program groups based on user input.
   */
  public filterProgramGroups(filterValue: string): void
  {
    this.searchTerm = filterValue;
    this.programGroupsFiltered = sortBy(this.programGroups
      .filter(group => group.name.toLowerCase().includes(filterValue.toLowerCase())), ['name']);
  }

  /**
   * Method to indicate if the program group is selected.
   * This is use to set the custom checkbox of the kendo-multiselect.
   *
   * @param filterItem Filter property name
   * @param itemValue Item value id
   */
  public isGroupSelected(filterItem: string, itemValue: any): boolean
  {
    return this[filterItem].value && this[filterItem].value.map((m: Group) => m.id).includes(itemValue);
  }

  /**
   * Remove metric from selection.
   */
  public removeMetric(i: number): void
  {
    const metrics = this.programForm.controls.metrics;
    (metrics as UntypedFormArray).removeAt(i);
    this.programForm.markAsDirty(); // Must force mark as dirty when removing a metric.
  }

  public showTooltip(e: ElementRef, tooltip: ElementRef): void
  {
    const tooltipDirective = this.tooltipDir.toArray().find(t => t.tooltipWrapper.nativeElement === tooltip);
    if (tooltipDirective)
    {
      tooltipDirective.toggle(e, true); // Show the tooltip
    }
  }

  public hideTooltip(tooltip: ElementRef): void
  {
    const tooltipDirective = this.tooltipDir.toArray().find(t => t.tooltipWrapper.nativeElement === tooltip);
    if (tooltipDirective)
    {
      tooltipDirective.hide(); // Show the tooltip
    }
  }

  /**
   * Load the program groups.
   *
   * @param groupIds List of groupIds
   * @param allGroups All groups
   */
  private setProgramGroups(groupIds: Array<number>, allGroups: Array<Group>): void
  {
    const groups = sortBy(allGroups.filter(g => groupIds.includes(g.id)), ['name']);
    this.program.groups = groups;
  }

  /**
   * Load the program metrics.
   *
   * @param metrics List of metrics
   * @param allMetrics All metrics
   */
  private setProgramMetrics(metrics: Array<any>, allMetrics: Array<any>): void
  {
    metrics.forEach(m =>
    {
      const metric = allMetrics.find(x => x.id === m.metricId);
      m.metric = metric;
    });
    this.program.metrics = metrics;
  }

  /**
   * Initializes the channel FormGroup.
   */
  private buildForm(): void
  {
    const leaderId = this.program && this.program.leader ? this.program.leader.id : 0;
    const leaderName = this.program && this.program.leader ? this.program.leader.name : null;
    const categoryId = this.program && this.program.category ? this.program.category.id : 0;
    const categoryName = this.program && this.program.category ? this.program.category.name : null;
    const organizationId = this.program && this.program.organization ? this.program.organization.id : 0;
    const organizationName = this.program && this.program.organization ? this.program.organization.name : null;

    this.programForm = this.formBuilder.group({
      id: this.program ? this.program.id : 0,
      name: [{ value: this.program ? this.program.name : null, disabled: this.disableFormControl() },
      [Validators.required, Validators.maxLength(255)]],
      description: [{ value: this.program ? this.program.description : null, disabled: this.disableFormControl() }, Validators.required],
      version: this.program ? this.program.version : 0,
      active: this.program ? this.program.active : true,
      leader: [{ value: { id: leaderId, name: leaderName }, disabled: this.disableFormControl() },
      Validators.required],
      category: [{ value: { id: categoryId, name: categoryName }, disabled: this.disableFormControl() },
      Validators.required],
      organization: [{
        value: { id: organizationId, name: organizationName },
        disabled: this.disableFormControl()
      }],
      isTemplate: this.program ? this.program.isTemplate : false,
      template: null,
      channels: this.formBuilder.array([]),
      metrics: this.formBuilder.array([]),
      groups: [{ value: sortBy(this.program.groups, ['name']), disabled: this.disableFormControl() }]
    });

    if (this.isNew)
    {
      this.programForm.reset(this.program);
    }

    // Set program's channels
    if (this.program.channels && !this.isNew)
    {
      // Load channels
      const channels = this.program.channels;
      if (channels !== undefined)
      {
        channels.forEach(d =>
        {
          this.addUpdateChannel(d.id, d.name, d.status, d.bpmId, d.bpmKey, d.bpmName, d.appId, null, d.version, this.program.id,
            null, d.canAccess);
        });
      }

      // Disable name if channel already exists
      this.disableChannelsName();
    }

    // Set program's metrics
    if (this.program.metrics && !this.isNew)
    {
      // Load metrics
      const metrics = this.program.metrics;
      if (metrics !== undefined)
      {
        metrics.forEach(d =>
        {
          this.addUpdateMetric(d.id, d.metric, d.target, d.rate, d.numerator, d.denominator, d.version);
        });
      }
    }

    // If new, must add a channel entry to show up
    if (this.isNew)
    {
      // Copy properties from Program Template
      this.programForm.get('template').valueChanges.subscribe({
        next: (selectedTemplate: Program) =>
        {
          // Remove all Channels copied from previous Program Template (if any)
          this.removeChannelsCopiedFromTemplate();
          this.removeMetricsCopiedFromTemplate();

          if (selectedTemplate && selectedTemplate !== undefined)
          {
            this.name.setValue(selectedTemplate.name);
            this.description.setValue(selectedTemplate.description);
            this.leader.setValue({ id: selectedTemplate.leader.id, name: selectedTemplate.leader.name });
            this.category.setValue({ id: selectedTemplate.category.id, name: selectedTemplate.category.name });
            const groups = sortBy(this.programGroups.filter(g => selectedTemplate.groups.includes(g.id)), ['name']);
            this.groups.setValue(groups);

            // Copy channels from template
            this.addChannelsFromTemplate(selectedTemplate.channels);

            // Copy metrics from template
            this.addMetricsFromTemplate(selectedTemplate.metrics);
          }
        }
      });
    }
  }

  private getProgram(): void
  {
    this.loading = true;
    this.programService.getProgram(this.programId).subscribe({
      next: (data) =>
      {
        // Set program data
        this.setProgramData(data);
        this.buildForm();
      },
      error: (error) =>
      {
        // failed to retrieve channel, reset the view model and render with the error set for display
        this.logger.error(error);
        this.messageHandlerService.displayError(error);
        this.program = new Program();
        this.buildForm();
      },
      complete: () =>
      {
        this.loading = false;
      }
    });
  }

  /**
   * Method to set program's data. Some manipulations are required.
   *
   * @param data Program data.
   */
  private setProgramData(data: any): void
  {
    this.program = data;
    this.setProgramMetrics(data.metrics, this.allMetrics);
    this.setProgramGroups(data.groups, this.programGroups);
  }

  /**
   * Create a channels control being used by the form.
   *
   * @param id Channel Id
   * @param name Channel Name
   * @param status Channel Status
   * @param bpmId Business Process Id
   * @param bpmKey Business Process Key
   * @param bpmName Business Process Name
   * @param appId Business Process Application Id
   * @param copyChannelId When copied from a template, this indicates the channelId being copied
   * @param version Channel version number returned by service-layer
   * @param programId Current Program Id
   * @param canAccess Indicate if has Channel access
   * @returns formBuildGroup
   */
  private createChannelItem(id: number, name: string, status: string,
    bpmId: string, bpmKey: string, bpmName: string, appId: string, copyChannelId: number,
    version: number, programId: number, templateChannel: Channel, canAccess: boolean): UntypedFormGroup
  {
    const group: any = {};
    group.id = id;
    group.name = [{ value: name, disabled: this.disableFormControl() }, Validators.required];
    group.status = status;
    group.version = version;
    group.programId = programId;
    group.bpmId = bpmId;
    group.bpmKey = bpmKey;
    group.bpmName = bpmName;
    group.appId = appId;
    group.channelZip = null;
    group.modelFileName = null;
    group.copyChannelId = copyChannelId;
    group.canAccess = canAccess;
    group.templateChannel = templateChannel;

    return this.formBuilder.group(group);
  }

  /**
   * Add/Update program's channel.
   *
   * @param id Channel Id
   * @param name Channel Name
   * @param status Channel Status
   * @param bpmId Business Process Id
   * @param bpmKey Business Process Key
   * @param bpmName Business Process Name
   * @param appId Business Process Application Id
   * @param copyChannelId When copied from a template, this indicates the channelId being copied
   * @param version Channel version number returned by service-layer
   * @param programId Current Program Id
   * @param templateChannel Template Channel
   * @param canAccess Indicate if has Channel access
   */
  private addUpdateChannel(id: number = null, name = '', status = '',
    bpmId: string = null, bpmKey: string = null, bpmName: string = null, appId: string = null, copyChannelId: number = null,
    version = 0, programId: number, templateChannel: Channel = null, canAccess = true): void
  {
    this.channels = this.programForm.get('channels') as UntypedFormArray;
    this.channels.push(this.createChannelItem(id, name, status, bpmId, bpmKey, bpmName, appId, copyChannelId, version, programId,
      templateChannel, canAccess));
  }

  private disableChannelsName(): void
  {
    this.programForm.get('channels').controls.forEach(control =>
    {
      control.disable();
    });
  }

  /**
   * Add/Update program's metric.
   *
   * @param id Metric Id
   * @param metric Metric object selected
   * @param target Target when Rate Based type
   * @param rate Rate when Rate Based type
   * @param numerator Numerator value when manually entered
   * @param denominator Denominator value when manually entered
   * @param copyMetricId Copy metric from Template
   * @param version Channel version number returned by service-layer
   */
  private addUpdateMetric(id: number = null, metric: any = null,
    target: number = null, rate: number = null, numerator: number = null, denominator: number = null,
    copyMetricId: number = null, version = 0): void
  {
    this.metrics = this.programForm.get('metrics') as UntypedFormArray;
    this.metrics.push(this.createMetricItem(id, metric, target, rate, numerator, denominator, copyMetricId, version));

    // Register metric changes
    const controlIndex = this.metrics.controls.length - 1;
    this.metrics.controls[controlIndex].get('metric').valueChanges.subscribe({
      next: (selectedMetric: any) =>
      {
        this.metricChanges(controlIndex, selectedMetric);
      }
    });
    this.metricChanges(controlIndex, metric);
  }

  private metricChanges(controlIndex: number, metric: any): void
  {
    if (metric !== undefined && metric !== null)
    {
      // Target required?
      if (metric.metricType === 'RATE_BASED')
      {
        this.metrics.controls[controlIndex].get('target').setValidators([Validators.required]);
        // If metric rate mode is manual, set required validator
        if (metric.metricRateMode === 'MANUAL')
        {
          this.metrics.controls[controlIndex].get('rate').setValidators([Validators.required]);
        }
        else
        {
          this.metrics.controls[controlIndex].get('rate').setValidators([]);
        }
      }
      else
      {
        this.metrics.controls[controlIndex].get('target').setValidators([]);
        this.metrics.controls[controlIndex].get('rate').setValidators([]);
      }
      // Numerator required?
      if (metric.numerator === null)
      {
        this.metrics.controls[controlIndex].get('numerator').setValidators([Validators.required]);
      }
      else
      {
        this.metrics.controls[controlIndex].get('numerator').setValidators([]);
      }
      // Denominator required?
      if (metric.denominator === null)
      {
        this.metrics.controls[controlIndex].get('denominator').setValidators([Validators.required]);
      }
      else
      {
        this.metrics.controls[controlIndex].get('denominator').setValidators([]);
      }
    }
    this.metrics.controls[controlIndex].get('target').updateValueAndValidity();
    this.metrics.controls[controlIndex].get('rate').updateValueAndValidity();
    this.metrics.controls[controlIndex].get('numerator').updateValueAndValidity();
    this.metrics.controls[controlIndex].get('denominator').updateValueAndValidity();
  }

  /**
   * Create a metrics control being used by the form.
   *
   * @param id Metric Id
   * @param metric Metric object selected
   * @param target Target when Rate Based type
   * @param rate Rate when Rate Based type
   * @param numerator Numerator value when manually entered
   * @param denominator Denominator value when manually entered
   * @param copyMetricId Copy metric id from Template
   * @param version Channel version number returned by service-layer
   * @returns formBuildGroup
   */
  private createMetricItem(id: number, metric: any,
    target: number, rate: number,
    numerator: number, denominator: number,
    copyMetricId: number,
    version: number): UntypedFormGroup
  {
    const group: any = {};

    group.id = id;
    group.metric = [{ value: metric, disabled: this.disableFormControl() }, Validators.required];
    group.target = [{ value: target, disabled: this.disableFormControl() }];
    group.rate = [{ value: rate, disabled: this.disableFormControl() }];
    group.numerator = [{ value: numerator, disabled: this.disableFormControl() }];
    group.denominator = [{ value: denominator, disabled: this.disableFormControl() }];
    group.copyMetricId = copyMetricId;
    group.version = version;

    return this.formBuilder.group(group);
  }

  /**
   * This method returns the bpmId from the selected template matching the Business Process Key creation and copyChannelId (bpmKeyMaps).
   *
   * @param key Business Process Key
   * @param version Business Process Version
   * @param templateId Template Id selected
   */
  private findBpmIdFromTemplate(key: string, bpmKeyMaps: Map<string, number>, templateId: number): string
  {
    let bpmId: string;
    // Check if key is in the map and the Channel is copied from the template.
    if (bpmKeyMaps.has(key) && bpmKeyMaps.get(key) !== null)
    {
      // Locate the template
      const templateObj = this.programTemplates.find(x => x.id === templateId);
      if (templateObj !== undefined)
      {
        // Locate the right Channel from the template
        const channelObj = templateObj.channels.find(x => x.id === bpmKeyMaps.get(key));
        if (channelObj !== undefined)
        {
          // Return the bpmId
          bpmId = channelObj.bpmId;
        }
      }
    }
    return bpmId;
  }

  private addChannelsFromTemplate(sourceChannels: any[]): void
  {
    if (sourceChannels.length > 0)
    {
      sourceChannels.forEach(d =>
      {
        this.addUpdateChannel(null, d.name, 'Offline', null, null, null, null, d.id, 0, null, null, true);
      });
    }
  }

  private addMetricsFromTemplate(sourceMetrics: any[]): void
  {
    if (sourceMetrics.length > 0)
    {
      sourceMetrics.forEach(d =>
      {
        const metric = this.allMetrics.find(x => x.id === d.metricId);
        this.addUpdateMetric(null, metric, d.target, d.rate, d.numerator, d.denominator, d.id, 0);
      });
    }
  }

  /**
   * When template is removed, all Channels with copyChannelId are removed.
   */
  private removeChannelsCopiedFromTemplate(): void
  {
    const channels = this.programForm.controls.channels;
    let i = (channels as UntypedFormArray).length - 1;
    while (i > -1)
    {
      if ((channels as UntypedFormArray).controls[i].get('copyChannelId').value !== null)
      {
        this.removeChannel(i, 0);
      }
      i--;
    }
  }

  /**
   * When template is removed, all Metrics with copyMetricId are removed.
   */
  private removeMetricsCopiedFromTemplate(): void
  {
    const metrics = this.programForm.controls.metrics;
    let i = (metrics as UntypedFormArray).length - 1;
    while (i > -1)
    {
      if ((metrics as UntypedFormArray).controls[i].get('copyMetricId').value !== null)
      {
        this.removeMetric(i);
      }
      i--;
    }
  }

  /**
   * Set grouped Channels for each Programs
   */
  private setGroupedTemplateChannels(): void
  {
    // Build the grouped Channels
    const groupedChannels = groupBy(this.templateChannels, [{ field: 'programName' }]);
    this.templateGroupedChannels.forEach(d =>
    {
      const items = sortBy(d.items, ['name']);
      d.items = items;
    });
    this.templateGroupedChannels = sortBy(groupedChannels, ['value']);
  }
}
